import { render, staticRenderFns } from "./workflowForm.vue?vue&type=template&id=61ebb652"
import script from "./workflowForm.vue?vue&type=script&lang=js"
export * from "./workflowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports